import { TextButton } from '@components/Buttons';
import { Box, List, ListItem, Tooltip, Typography } from '@mui/material';
import { IHelperTextProp } from 'types/tooltips';
import { uniqueId } from 'lodash';
import React from 'react';

const DynamicValueHelperText = (props: IHelperTextProp) => {
	const { meta, content, children } = props;
	const { header, footer } = content;
	return (
		<Box pt={1} component="span" display="block">
			{meta.example && (
				<Typography fontSize="small" color="GrayText" component="span">
					{meta.example}
				</Typography>
			)}
			<br />
			<Tooltip
				title={
					<Typography variant="subtitle2" sx={{ wordBreak: 'break-word' }}>
						{header && (
							<Box mb={2} fontSize="small">
								{header}
							</Box>
						)}
						{children.map((item) => (
							<Box mb={2} key={`item-${uniqueId()}`}>
								{item.title && (
									<Typography fontSize="small">{item.title}</Typography>
								)}
								<List dense disablePadding>
									{item.children.map((child) => (
										<ListItem sx={{ padding: 0 }} key={`child-${uniqueId()}`}>
											<Typography
												sx={{ whiteSpace: item.meta?.whitespace || 'normal' }}
												fontSize="small"
											>
												{child}
											</Typography>
										</ListItem>
									))}
								</List>
							</Box>
						))}
						{footer && <Box mb={0}>{footer}</Box>}
					</Typography>
				}
				placement="left"
			>
				<span>
					<TextButton sx={{ minHeight: 0, minWidth: 0, padding: 0 }}>
						<Typography variant="subtitle2">{meta.trigger}</Typography>
					</TextButton>
				</span>
			</Tooltip>
		</Box>
	);
};

export default DynamicValueHelperText;
